import { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { routes } from './AppRoutes';
import { Loader } from '@mantine/core';

export default function AppRouter() {
  const routing = useRoutes(routes);

  return (
    <Suspense fallback={<Loader />}>
      {routing}
    </Suspense>
  );
}
